import * as api from "util/api";
import { Role } from "appz";

export const loginUser = (userName: string, password: string) =>
    api.json.post("api/user/loginuser", { userName, password });

export const signOutUser = () => api.json.post("api/user/signoutuser", {});

export const fetchUser = (id: string) =>
    api.json.get("api/user/getuser", { id });

export const fetchUsers = (
    pageNumber: number = 1,
    resultsPerPage: number = 30,
    searchText: string = "",
) =>
    api.json.get("api/user/GetPaginatedUsers", {
        pageNumber,
        resultsPerPage,
        searchText,
    });

export const deleteUser = (id: string) =>
    api.text.post("api/user/deleteuser", { id });

export const resetPassword = (email: string) =>
    api.json.post("api/user/resetPassword", { email });

export const fetchRoles = () => api.json.get("api/user/getroles");

export const updateUser = (
    id: string,
    email: string,
    userName: string,
    roles: Array<Role>,
    softDeleted: boolean,
) =>
    api.text.post("api/user/updateuser", {
        id,
        email,
        userName,
        roles,
        softDeleted,
    });

export const addUser = (
    email: string,
    userName: string,
    roles: Array<Role>,
    password: string,
    repeatedPassword: string,
) => {
    if (password !== repeatedPassword) {
        return {
            success: false,
            message: "Passwords does not match.",
        };
    }

    return api.text.post("api/user/adduser", {
        email,
        userName,
        roles,
        password,
        repeatedPassword,
    });
};
